export const ACTION_SET_BOOK_NAME = 'SET_BOOK_NAME';
export const ACTION_SET_TOGGLE_BOOK_NAME = 'SET_TOGGLE_BOOK_NAME';
export const ACTION_SET_TOGGLE_IMPORT_WAY = 'SET_TOGGLE_IMPORT_WAY';
export const ACTION_SET_UP_BOOK_INFO = 'SET_UP_BOOK_INFO';
export const ACTION_SET_EDITOR_BOOK_INFO = 'SET_EDITOR_BOOK_INFO';

export const setBookName = (name) => {
    return {
        type: ACTION_SET_BOOK_NAME,
        payload: name
    }
}
export const editorBookInfo = (info) => {
    return {
        type: ACTION_SET_EDITOR_BOOK_INFO,
        payload: info
    }
}

export const upBookInfo= (params) => {
    return {
        type: ACTION_SET_UP_BOOK_INFO,
        payload: params
    }
}

export const setToggleBookName = (state) => {
    return {
        type: ACTION_SET_TOGGLE_BOOK_NAME,
        payload: state
    }
}

export const setToggleImportWay = state => {
    return {
        type: ACTION_SET_TOGGLE_IMPORT_WAY,
        payload: state
    }
}
